import { render, staticRenderFns } from "./vue-scroll-snap.vue?vue&type=template&id=09f17ac9"
import script from "./vue-scroll-snap.vue?vue&type=script&lang=js"
export * from "./vue-scroll-snap.vue?vue&type=script&lang=js"
import style0 from "./vue-scroll-snap.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports